import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RolloutProgressReportEntities } from '../../entities/index';
import { InspectionReportInitService } from '../../initial-values/inspection-report-init.service';

@Injectable({
  providedIn: 'root',
})
export class RolloutProgressReportGroupsApiService {
  url: string;

  constructor(
    private readonly http: HttpClient,
    private readonly initService: InspectionReportInitService,
  ) {
    this.url = this.initService.getInitValueProperty('urls').reportGroups;
  }

  getReportGroups = (reportId: string) =>
    this.http.get<RolloutProgressReportEntities.v3.ReportGroupsResponse>(
      `${this.url}/${reportId}/groups`,
    );

  getReportGroupByName = (
    reportId: string,
    groupName: RolloutProgressReportEntities.v3.Groups,
  ) =>
    this.http.get<RolloutProgressReportEntities.v3.GroupObjectResponse>(
      `${this.url}/${reportId}/groups/${groupName}`,
    );

  getInspectionReportGroupsData = (
    reportId: string,
    typeId: RolloutProgressReportEntities.v3.MarkerTypes,
  ) =>
    this.http.get<RolloutProgressReportEntities.v3.InspectionReportGroupsData>(
      `${this.url}/${reportId}/groups/combined?pointType=${typeId}`,
    );
}
